import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiTimeRange } from '@euler/model/bi/query';
import { memo } from 'react';
import { View } from 'react-native';
import { BiButton } from '../../components/ui/BiButton';
import { AbsoluteRangeFields } from './AbsoluteRangeFields';
import { RollingRangeFields } from './RollingRangeFields';

/** The dashboard's own range beyond the presets: rolling, or named dates. */
export const DateRangePanel = memo(
  ({
    visible,
    value,
    onPick,
    onClose,
  }: {
    visible: boolean;
    value: BiTimeRange | undefined;
    onPick: (range: BiTimeRange) => void;
    onClose: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <BottomPanel visible={visible} onClose={onClose} fitContent>
        <View style={{ padding: rpx(24), gap: rpx(14) }}>
          <View style={{ gap: rpx(4) }}>
            <Typography.Text medium size={rpx(15)} color={aiColors.foreground}>
              自定义日期范围
            </Typography.Text>
            <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
              「最近」会随时间滚动；指定日期则固定不变。
            </Typography.Text>
          </View>
          {visible ? (
            <>
              <RollingRangeFields value={value} onPick={onPick} />
              <AbsoluteRangeFields value={value} onPick={onPick} />
            </>
          ) : null}
          <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
            <BiButton title="完成" tone="primary" onPress={onClose} />
          </View>
        </View>
      </BottomPanel>
    );
  },
);
